import React from 'react'

import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import Button from '@components/shared/Button'
import PurchaseLearnDialog from '@components/shared/dialogs/PurchaseLearnDialog'
import { useDialogStore } from '@stores/dialog.store'
import { isLearnPcPreview } from '@utils/page-routes'

const PrintPdfButton: React.FC = () => {
  const { t } = useTranslation()
  const openDialog = useDialogStore((s) => s.openDialog)
  const { pathname } = useLocation()

  const onClick = () => {
    if (isLearnPcPreview(pathname)) {
      openDialog('purchase_learn')
    } else {
      clickEmbedPrint()
    }
  }
  return (
    <>
      <Button
        variant="primary"
        className="py-1.5 px-3 flex flex-row items-center justify-center text-md"
        onClick={onClick}>
        <i className="mr-1 leading-4 nf-icon nf-print text-h3" />
        {t('action.printPdf')}
      </Button>
      <PurchaseLearnDialog />
    </>
  )
}

export default PrintPdfButton

/**
 * Finds the embed iframe element on the page and attempts to click the print button within it. This definitely is a
 * hackish way to do it, but assuming we don't change the embed ID and print button class name, we should be good.
 */
function clickEmbedPrint(): void {
  const embedEl = document.getElementById('embed_score') as HTMLIFrameElement | null
  if (embedEl?.contentWindow) {
    const innerEmbed = embedEl.contentWindow.document.getElementById(
      'embedIframe'
    ) as HTMLIFrameElement | null
    const innerButton = innerEmbed?.contentWindow?.document.querySelector(
      '.printSimple'
    ) as HTMLButtonElement | null
    if (innerButton) {
      innerButton.click()
    } else {
      const printBtns = embedEl.contentWindow.document.getElementsByClassName('printSimple')
      if (printBtns?.length) (printBtns[0] as HTMLButtonElement).click()
    }
    document.getElementById('title-details-close-btn')?.click()
  }
}
